/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-24 18:18:52
 * @FilePath: /unifyxp-v2-store-portal/src/router/PermissionRoute.tsx
 */
import React from 'react';
import { Route } from './Components/Route';
import I18nWrapper from 'src/constrains/I18nWrapper';
function GeneralRoute({ component: Component, ...rest }) {
  //const { permissionGroup, permissionGroupGenerate, source } = rest;

  // const v = isUserValid({
  //   resourcesGroup: permissionGroup,
  //   roleGroup,
  // });

  //const isLogin = checkIsLogin();
  // console.log('', isLogin, v);
  // if (!isLogin) {
  //   return <Redirect to='/login' />;
  // }
  //console.log('...PermissionRoute', rest);
  //const { multipleLanguageProps } = rest;
  return (
    <Route
      {...rest}
      render={(props) => {
        // const params = get(props, 'match.params');

        return (
          <I18nWrapper _props={props}>
            <Component
              {...props}
              // __salesChannelMultiLanguage={multipleLanguageProps}
            />
          </I18nWrapper>
        );
      }}
    />
  );
}
export default GeneralRoute;
